<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><img alt="Pack of Cards" src="images/9780802197351_0001.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006a_Chapter_Opening.vue?29869380